import capitalize from './capitalize';

export const startCase = str => str.replace(/[\s_-]/g, ' ').replace(/([a-z])([A-Z])/g, '$1 $2').replace(/([^\W]+[^\s]*) */g, capitalize).trim();
export const camelCase = str => startCase(str).split(' ').map((n, i) => i > 0 ? n : n.toLowerCase()).join('');
export const pascalCase = str => startCase(str).replace(/\s/g, '');
export const kebabCase = str => startCase(str).toLowerCase().replace(/\s/g, '-');
export const snakeCase = str => startCase(str).toLowerCase().replace(/\s/g, '_');
export const titleCase = str => str.split(' ').map(capitalize).join(' ');
